import {
  PhoneNumberUtil,
  PhoneNumberFormat as PNF
} from 'google-libphonenumber'

import Util from 'service/util'

const phoneUtil = PhoneNumberUtil.getInstance()

const CompanyPhoneBook = Object.freeze({
  "85263586335": "TK", // whatsapp API
  "85251187438": "TK", // districts
  "85251189446": "TK", // districts
  "85296066162": "TK", // districts
  "85284038986": "KY", // whatsapp API
  "85255463735": "KY",
  "85295777005": "PF",
  "85246114788": "CO",
  "85268808833": "DF",
  "85255456142": "HK",
})

export const getPrimaryContact = (contacts) =>
{
  if (!contacts) return null
  return contacts.filter(c => c.c_type == 1)[0]
}

export const tryParsePhoneNumber = (number) =>
{
  try
  {
    if (String(number).length == 8 && number[0] != '+') {
      number = '852' + number
    }

    return phoneUtil.format(phoneUtil.parse(`+${number}`), PNF.INTERNATIONAL)
  }
  catch
  {
    return number
  }
}

export const adjustMessageData = (msg) =>
{
  msg.cid = msg.uid || msg.wa_id
  const phoneNumber = tryParsePhoneNumber(msg.wa_id)
  msg.phoneNumber   = phoneNumber
  msg.sent_time     = Util.LongDate(msg.sent_time)
  msg.sent_company  = CompanyPhoneBook[msg.wa_id]
  return msg
}
